import { HelpAndGuidanceResult } from '../../lib/helpAndGuidance/types';
import React from 'react';
import cn from 'classnames';
import coverBlue from './coverBlue.svg';
import coverCovid from './coverCovid.png';
import coverGreen from './coverGreen.svg';
import coverOrange from './coverOrange.svg';
import coverPurple from './coverPurple.svg';
import coverRed from './coverRed.svg';
import coverStrava from './coverStrava.png';
import coverTom from './coverTom.png';

export type Props = Pick<
  HelpAndGuidanceResult,
  'url' | 'image' | 'title' | 'category' | 'description'
> & {
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
};

const imageSrc = (image: Props['image']): string => {
  switch (image) {
    case 'blue':
      return coverBlue;
    case 'green':
      return coverGreen;
    case 'orange':
      return coverOrange;
    case 'purple':
      return coverPurple;
    case 'red':
      return coverRed;
    case 'covid':
      return coverCovid;
    case 'tom':
      return coverTom;
    case 'strava':
      return coverStrava;
  }
};

const HelpAndGuidanceCard: React.FC<Props> = ({
  url,
  image,
  title,
  description,
  category,
  onClick,
}) => (
  <a
    href={url}
    onClick={onClick}
    className={cn(
      'jg-search-result-card',
      'jg-text-no-underline@hover',
      'jg-display-flex jg-flex-column'
    )}
    data-testid="jg-search-result-card"
  >
    <div
      className={cn(
        'jg-search-result-card__inner',
        'jg-background--white-smoke@hover',
        'jg-space-mxs jg-space-msm@md',
        'jg-br jg-bd jg-bd--very-light-grey',
        'jg-flex-g1 jg-display-flex jg-flex-column'
      )}
    >
      <div
        className={cn(
          'jg-search-result-card__image-ratio-wrapper',
          'jg-position-relative'
        )}
      >
        <div
          className={cn(
            'jg-search-result-card__image-wrapper',
            'jg-position-absolute jg-pin',
            'jg-display-flex jg-flex-aic jg-flex-jcc'
          )}
        >
          <img
            className="jg-search-result-card__image--help-and-guidance"
            src={imageSrc(image)}
            alt=""
          />
        </div>
      </div>
      <div className="jg-space-psm jg-flex-g1 jg-display-flex jg-flex-column">
        <div className="jg-flex-g1">
          <h3
            className={cn(
              'jg-text--large-regular jg-color--nero jg-space-mbxs'
            )}
          >
            {title}
          </h3>
          <p
            className={cn(
              'jg-text--medium-light jg-color--nobel',
              'jg-space-mbn'
            )}
          >
            {description.split('\n').map((str, i) => (
              <React.Fragment key={i}>
                {str}
                <br />
              </React.Fragment>
            ))}
          </p>
        </div>
        {category && (
          <p
            className={cn(
              'jg-text--medium jg-color--nero',
              'jg-space-mbn jg-space-mtxs jg-space-mtsm@md'
            )}
          >
            {category}
          </p>
        )}
      </div>
    </div>
  </a>
);

export default React.memo(HelpAndGuidanceCard);
